import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../../assets/common.scss';
import { IntegrityMonitorRuleProcessingModeOption } from '@nirvana/shared/dtos/types/policies/common';

export const templateIntegrityMonitorRealTimePanel = document.createElement('template');

templateIntegrityMonitorRealTimePanel.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
    <div class="im-policy-form-section">

      <gz-form-field id="im-realtime-enabled">
          <gz-checkbox gz-form-input></gz-checkbox>
      </gz-form-field>

      <gz-title fontWeight="500" fontSize="18" id="im-realtime-rule-processing-mode-title"></gz-title>
      <gz-form-field id="im-realtime-rule-processing-mode" required>
        <gz-radio-group gz-form-input>
          <gz-radio value="${IntegrityMonitorRuleProcessingModeOption.FAST}" id="im-realtime-rule-processing-mode-fast"></gz-radio>
          <gz-radio value="${IntegrityMonitorRuleProcessingModeOption.NORMAL}" id="im-realtime-rule-processing-mode-normal"></gz-radio>
          <gz-radio value="${IntegrityMonitorRuleProcessingModeOption.SLOW}" id="im-realtime-rule-processing-mode-slow"></gz-radio>
        </gz-radio-group>
        <gz-input-error></gz-input-error>
      </gz-form-field>


      <gz-title fontWeight="500" fontSize="18" id="im-realtime-mode-title"></gz-title>
      <gz-form-field id="im-realtime-mode" required>
        <gz-radio-group gz-form-input>
          <gz-radio id="im-realtime-mode-baseline"></gz-radio>
          <gz-radio id="im-realtime-mode-rule-sets"></gz-radio>
        </gz-radio-group>
        <gz-input-error></gz-input-error>
      </gz-form-field>

      <gz-labeled-content id="policy-rule-sets-section-labeled-content" hasFormLabelWidth labelFontSize="14">
        <gz-integrity-monitor-policy-rule-sets-section></gz-integrity-monitor-policy-rule-sets-section>
      </gz-labeled-content>
    </div>
  </div>
`;
